import { useQuery } from '@tanstack/vue-query'
import { useI18n } from 'vue-i18n'
import { getCountries } from '@/features/merchants/api/get-countries'

/** The countries list only changes with a deploy, so it is fetched once per locale. */
export function useCountries() {
  const { locale } = useI18n()

  return useQuery({
    queryKey: ['countries', locale],
    queryFn: () => getCountries(locale.value),
    staleTime: Infinity,
  })
}
